import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
    initiatingUpdateFlow: false,
    initiatingUpdateFlowError: "",

    updateLicenseInProgress: false,
    updateLicenseError: "",

    documentUploadStarted: false,
    documentUploadWorking: false,
    documentUploadCompleted: false,
    documentUploadErrors: [],

    applicationData: {},
    applicationNumber: "",
}

export const updateSlice = createSlice({
    name: 'update',
    initialState: INITIAL_STATE,
    // Reducers describe operations on state. Under the hood, reducers take the
    // current state and modify it in some manner then return the modified state.
    // Redux stores the modified state as the current state.  Subsequent reducers
    // will then operate on the modified state - thus, state changes accumulate/persist
    reducers: {
        setInitiatingUploadFlowInProgress: (state) => {
            state.initiatingUpdateFlow = true;
            state.initiatingUpdateFlowError = "";

            state.documentUploadStarted = false
            state.documentUploadWorking = false
            state.documentUploadCompleted = false;
        },
        setInitiatingUploadFlowComplete: (state, action) => {
            state.initiatingUpdateFlow = false
            state.initiatingUpdateFlowError = action.payload
        },
        setUpdateLicenseInProgress: (state) => {
            state.updateLicenseInProgress = true
            state.initiatingUpdateFlowError = ""
            state.documentUploadErrors = []
        },
        setUpdateLicenseCompleted: (state) => {
            state.updateLicenseInProgress = false
        },
        setUpdateLicenseError: (state, action) => {
            state.updateLicenseError = action.payload
        },
        updatePermitData: (state, action) => {
            state.applicationData = {
                ...state.applicationData,
                ...action.payload,
            }
        },
        removeRegistrantData: (state) => {
            delete state.applicationData.registrant;
        },
        removeContactsData: (state) => {
            delete state.applicationData.contacts;
        },
        removePropertyDetailsData: (state) => {
            delete state.applicationData.propertyDetails;
        },
        removeListingsData: (state) => {
            delete state.applicationData.listings;
        },
        setUpdateApplicationNumber: (state, action) => {
            state.applicationNumber = action.payload
        },
        setDocumentUploadStarted: (state, action) => {
            state.documentUploadErrors = []
            state.documentUploadWorking = false
            state.documentUploadCompleted = false
            state.documentUploadStarted = action.payload
        },
        setDocumentUploadWorking: (state, action) => {
            state.documentUploadStarted = false
            state.documentUploadCompleted = false
            state.documentUploadWorking = action.payload
        },
        setDocumentUploadCompleted: (state, action) => {
            state.documentUploadStarted = false
            state.documentUploadWorking = false
            state.documentUploadCompleted = action.payload
        },
        setDocumentUploadError: (state, action) => {
            state.documentUploadErrors = [
                ...state.documentUploadErrors,
                action.payload,
            ]
        },
        clearDocumentUploadError: (state) => {
            state.documentUploadErrors = []
        },
        resetDocumentUploadProgressStatus: (state) => {
            state.documentUploadStarted = false
            state.documentUploadWorking = false
            state.documentUploadCompleted = false
        },
        resetUpdateState: (state) => INITIAL_STATE,
    },
})

export const {
    setInitiatingUploadFlowInProgress,
    setInitiatingUploadFlowComplete,
    updatePermitData,
    removeRegistrantData,
    removeContactsData,
    removeListingsData,
    removePropertyDetailsData,
    setUpdateApplicationNumber,
    setDocumentUploadStarted,
    setDocumentUploadWorking,
    setDocumentUploadCompleted,
    setDocumentUploadError,
    resetDocumentUploadProgressStatus,
    resetUpdateState,
    setUpdateLicenseInProgress,
    setUpdateLicenseCompleted,
    setUpdateLicenseError
} = updateSlice.actions

export default updateSlice.reducer
